$(function () {
    new inlineCalendar();
});

class inlineCalendar {

    constructor($element) {

        this.minYear = 1900;

        if ($element) {
            this.create($element);
        } else {
            this.findAll();
        }
    }

    findAll() {

        let that = this;
        $('[data-component="inlineCalendar"]').each(function () {
            if (!$(this).hasClass('inlineCalendar-element')) {
                that.create($(this));
            }
        })
    }

    create($element) {
        let that = this;
        let $container = that.create__container();

        let $day = that.create__input('day');
        let $dots1 = that.create__input('dots');
        let $month = that.create__input('month');
        let $dots2 = that.create__input('dots');
        let $year = that.create__input('year');

        let $upArrow = that.create__arrow('up');
        let $downArrow = that.create__arrow('down');

        let $calendarButton = that.create__calendarButton();
        let $calendarInput = that.create__calendarInput();

        $element
            .addClass('inlineCalendar-element')
            .wrap($container);

        $container = $element.parent('.inlineCalendar');

        $container.append($calendarInput);
        $container.append($day);
        $container.append($dots1);
        $container.append($month);
        $container.append($dots2);
        $container.append($year);
        $container.append($upArrow);
        $container.append($downArrow);
        $container.append($calendarButton);

        let $flatpicker = that.flatPicker__init($calendarInput);

        that.event__changeFromOrigin($element, $day, $month, $year, $flatpicker);

        $upArrow.on('click', (e) => {
            e.preventDefault();
            that.event__change($element, $day, $month, $year, 'up', 'day', $flatpicker)
        });

        $downArrow.on('click', (e) => {
            e.preventDefault();
            that.event__change($element, $day, $month, $year, 'down', 'day', $flatpicker)
        });

        $element.on('change', (e) => {
            e.preventDefault();
            that.event__changeFromOrigin($element, $day, $month, $year, $flatpicker)
        });

        $day.on('change', (e) => {
            e.preventDefault();

            that.set__value($element, $day, $month, $year, that.get__dateFromInputs($day, $month, $year, $flatpicker));
        });

        $month.on('change', (e) => {
            e.preventDefault();

            that.set__value($element, $day, $month, $year, that.get__dateFromInputs($day, $month, $year, $flatpicker));
        });

        $year.on('change', (e) => {
            e.preventDefault();

            that.set__value($element, $day, $month, $year, that.get__dateFromInputs($day, $month, $year, $flatpicker));
        });

        $calendarInput.on('change', (e) => {
            e.preventDefault();

            that.set__value($element, $day, $month, $year, that.date__create(that.get__defaultValue($calendarInput, 'day'), that.get__defaultValue($calendarInput, 'month'), that.get__defaultValue($calendarInput, 'year')), $flatpicker);
        });

        $container.on('click', function (e) {
            if (e.target === e.currentTarget) {
                $day.focus().select();
            }
        });

        $container.on('focus', '*', function () {
            $container.addClass('focus');
        });

        $container.on('focusout', '*', function () {
            $container.removeClass('focus');
        });

        $calendarButton.on('click', function () {
            $calendarInput.focus();
        });

        $element.on('focus', function () {
            $day.focus().select();
        });

        $day.on('keydown', function (e) {
            if (e.keyCode === 40) {
                e.preventDefault();
                that.event__change($element, $day, $month, $year, 'down', 'day', $flatpicker);
            } else if (e.keyCode === 38) {
                e.preventDefault();
                that.event__change($element, $day, $month, $year, 'up', 'day', $flatpicker);
            }
        });

        $month.on('keydown', function (e) {
            if (e.keyCode === 40) {
                e.preventDefault();
                that.event__change($element, $day, $month, $year, 'down', 'month', $flatpicker);
            } else if (e.keyCode === 38) {
                e.preventDefault();
                that.event__change($element, $day, $month, $year, 'up', 'month', $flatpicker);
            }
        });

        $year.on('keydown', function (e) {
            if (e.keyCode === 40) {
                e.preventDefault();
                that.event__change($element, $day, $month, $year, 'down', 'year', $flatpicker);
            } else if (e.keyCode === 38) {
                e.preventDefault();
                that.event__change($element, $day, $month, $year, 'up', 'year', $flatpicker);
            }
        });

    }

    create__container() {
        return $('<div class="inlineCalendar"></div>');
    }

    create__arrow(type) {
        return $('<button type="button" class="inlineCalendar-arrow inlineCalendar-arrow--' + type + '"></button>');
    }

    create__calendarButton() {
        return $('<button type="button" class="inlineCalendar-calendar"></button>');
    }

    create__calendarInput() {
        return $('<input type="text" class="inlineCalendar-calendarInput">');
    }

    create__input(type) {
        let out = false;

        if (type === 'dots') {
            out = $('<div class="inlineCalendar-dots">.</div>');
        } else {
            out = $('<input class="inlineCalendar-input inlineCalendar-input--' + type + '" type="text">');
        }

        return out;
    }

    event__changeFromOrigin($element, $day, $month, $year, $flatpicker) {
        let that = this;

        let value__day = parseInt(that.get__defaultValue($element, 'day'));
        let value__month = parseInt(that.get__defaultValue($element, 'month'));
        let value__year = parseInt(that.get__defaultValue($element, 'year'));
        let date = that.date__createEmpty();

        if ($element.val() !== '') {
            date = that.date__create(value__day, value__month, value__year);
        }

        that.set__value($element, $day, $month, $year, date, $flatpicker);
    }

    event__change($element, $day, $month, $year, direction, type, $flatpicker) {
        let that = this;
        let value__day = that.get__value($day);
        let value__month = that.get__value($month);
        let value__year = that.get__value($year);

        let date = that.date__create(value__day, value__month, value__year, true);
        let parentDate = date;

        if (direction === 'up') {

            if (type === 'day') {
                date = that.date__create(parentDate.getDate() + 1, parentDate.getMonth(), parentDate.getFullYear(), false)
            } else if (type === 'month') {
                date = that.date__create(date.getDate(), date.getMonth() + 1, date.getFullYear(), false)
            } else {
                date = that.date__create(date.getDate(), date.getMonth(), date.getFullYear() + 1, false)
            }

        } else {

            if (type === 'day') {
                date = that.date__create(date.getDate() - 1, date.getMonth(), date.getFullYear(), false)
            } else if (type === 'month') {
                date = that.date__create(date.getDate(), date.getMonth() - 1, date.getFullYear(), false)
            } else {
                date = that.date__create(date.getDate(), date.getMonth(), date.getFullYear() - 1, false)
            }
        }

        that.set__value($element, $day, $month, $year, date, $flatpicker);
        $element.trigger("change");
    }

    get__value($element) {
        return parseInt($element.val());
    }

    get__dateFromInputs($day, $month, $year) {
        let that = this;

        let value__day = that.get__value($day);
        let value__month = that.get__value($month);
        let value__year = that.get__value($year);

        return that.date__create(value__day, value__month, value__year);
    }

    get__defaultValue($element, type) {
        let value = $element.val();
        let out = 0;

        if (value !== '') {
            if (type === 'day') {
                out = parseInt(value.split(".")[0]);
            } else if (type === 'month') {
                out = parseInt(value.split(".")[1]);
            } else {
                out = parseInt(value.split(".")[2]);
            }
        }

        return out;
    }

    set__value($element, $day__element, $month__element, $year__element, date, $flatpicker) {

        let value__day = date.getDate();
        let value__month = date.getMonth() + 1;
        let value__year = date.getFullYear();

        if (value__day < 10) {
            value__day = '0' + value__day;
        }

        if (value__month < 10) {
            value__month = '0' + value__month;
        }

        $day__element.val(value__day);
        $month__element.val(value__month);
        $year__element.val(value__year);

        $element.val(value__day + "." + value__month + "." + value__year);
        $flatpicker.setDate(date);

    }

    date__create(day, month, year, fixMonth = true) {
        let that = this;

        if (fixMonth) {
            month = month - 1; // months are 0 - 11
        }

        if (year < that.minYear) {
            year = that.minYear;
        }

        let date = new Date(year, month, day);

        if (!that.date__isValid(date)) {
            date = new Date();
        }

        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        return date;
    }

    date__createEmpty() {

        let date = new Date();

        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        return date;
    }

    date__isValid(d) {
        return d instanceof Date && !isNaN(d);
    }

    flatPicker__init($calendarInput) {
        return $calendarInput.flatpickr({
            enableTime: false,
            noCalendar: false,
            dateFormat: "d.m.Y",
            // minDate: 'today',
            locale: getLang(),
            nextArrow: "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 19'><path fill-rule='evenodd' d='M2.446 0L0 2.376 7.2 9.5 0 16.626 2.446 19 12 9.5z'/></svg>",
            prevArrow: "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 19'><path fill-rule='evenodd' d='M9.554 0L12 2.376 4.8 9.5l7.2 7.125L9.554 19 0 9.5z'/></svg>",
        });
    }

    range__isRange($element) {
        let out = false;

        if ($element.attr('data-inlineCalendar-range') !== undefined) {
            out = true;
        }
        return out;
    }
}